<ion-header no-border>
  <app-close-button [isModal]="isModal"></app-close-button>
</ion-header>

<ion-content class="custom-inputs">
  <div class="medium">
    <div class="page-title">{{ title | translate }}</div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <!-- Schedule Content -->
    <div class="schedule-content" *ngIf="!isLoading">

      <!-- Calendar Preview -->
      <div class="calendar-section">
        <app-schedule-calendar
          #scheduleCalendar
          [workDaysScheduleID]="workDaysScheduleID"
          [daysOffScheduleID]="daysOffScheduleID"
          [locationID]="locationID"
          [subjectType]="'worker'"
          [subjectID]="userID"
          [showLegend]="true"
          [highlightToday]="true"
          [readonly]="true"
        ></app-schedule-calendar>
      </div>

      <!-- Personal Time Off Section -->
      <div class="days-off-section">
        <div class="section-header">
          <h3>{{ 'WORK_SCHEDULE.My_Time_Off' | translate }}</h3>
          <ion-button class="add-button" color="secondary" fill="outline" size="small" (click)="addDayOff()">
            <ion-icon name="add" slot="start"></ion-icon>
            {{ 'WORK_SCHEDULE.Add_Time_Off' | translate }}
          </ion-button>
        </div>
        <p class="hint-text">{{ 'WORK_SCHEDULE.My_Time_Off_Hint' | translate }}</p>

        <!-- Upcoming Time Off List -->
        <div class="entries-list" *ngIf="upcomingTimeOff.length > 0">
          <ion-list>
            <ion-item *ngFor="let entry of upcomingTimeOff" class="entry-item">
              <ion-label>
                <h2>{{ getEntryDescription(entry) }}</h2>
                <p class="date-range" *ngIf="getEntryDateRange(entry)">{{ getEntryDateRange(entry) }}</p>
                <p class="time-range" *ngIf="getEntryTimeRange(entry)">{{ getEntryTimeRange(entry) }}</p>
                <p *ngIf="getEntryNotes(entry)" class="notes">{{ getEntryNotes(entry) }}</p>
              </ion-label>
              <ion-buttons slot="end">
                <ion-button fill="clear" class="edit-btn" (click)="editDayOff(entry)" *ngIf="canEditEntry(entry)">
                  <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button fill="clear" color="danger" class="delete-btn" (click)="deleteDayOff(entry)">
                  <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-item>
          </ion-list>
        </div>

        <!-- Empty State for Upcoming -->
        <div class="no-entries" *ngIf="upcomingTimeOff.length === 0">
          <p>{{ 'WORK_SCHEDULE.No_Personal_Time_Off' | translate }}</p>
        </div>

        <!-- Completed Time Off Section -->
        <div class="completed-section" *ngIf="completedTimeOff.length > 0">
          <h4 class="completed-header">{{ 'WORK_SCHEDULE.Completed_Time_Off' | translate }}</h4>
          <ion-list>
            <ion-item *ngFor="let entry of completedTimeOff" class="entry-item completed">
              <ion-label>
                <h2>{{ getEntryDescription(entry) }}</h2>
                <p class="date-range" *ngIf="getEntryDateRange(entry)">{{ getEntryDateRange(entry) }}</p>
                <p class="time-range" *ngIf="getEntryTimeRange(entry)">{{ getEntryTimeRange(entry) }}</p>
                <p *ngIf="getEntryNotes(entry)" class="notes">{{ getEntryNotes(entry) }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </div>

    </div>
  </div>
</ion-content>
